var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatbotMobileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 17,
    viewBox: "0 0 24 17",
    fill: "#ffffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 93"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 6",
    width: 24,
    height: 13.4996,
    rx: 6.74982,
    fill: "#212935"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 7",
    x: 3.19922,
    y: 2.40039,
    width: 18,
    height: 8.79976,
    rx: 4.39988,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2",
    d: "M15.9258 16.9495L21.2633 11.7871L15.9258 12.2246V16.9495Z",
    fill: "#212935"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 171"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 11",
    cx: 7.2,
    cy: 6.79958,
    rx: 1.2,
    ry: 1.19997,
    fill: "#212935"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 12",
    cx: 17.2,
    cy: 6.79958,
    rx: 1.2,
    ry: 1.19997,
    fill: "#212935"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatbotMobileIcon);
export default __webpack_public_path__ + "static/media/chatbot-mobile-icon.05a0b8b76ee8c3430a1054c6972c244e.svg";
export { ForwardRef as ReactComponent };